module.exports = __webpack_public_path__ + "static/media/contact.ab2b1ec4.png";